/**
 * ISO 3166-1 alpha-2 des corridors PawaPay (sélecteur Mobile Money).
 *
 * CG = Congo-Brazzaville (+242), CD = RD Congo / Kinshasa (+243).
 * Les deux doivent rester distincts : ce ne sont pas les mêmes opérateurs.
 */
export const PAWAPAY_COUNTRIES = [
  "AO",
  "BJ",
  "BF",
  "BI",
  "CM",
  "CF",
  "TD",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GM",
  "GH",
  "GN",
  "KE",
  "LS",
  "LR",
  "MG",
  "MW",
  "ML",
  "MR",
  "MZ",
  "NA",
  "NE",
  "NG",
  "RW",
  "SN",
  "SL",
  "SZ",
  "TZ",
  "TG",
  "UG",
  "ZM",
  "ZW",
] as const;
